import { TVKeyMap } from './types';

export const TIZEN_KEYS: TVKeyMap = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  RETURN: 10009,
  PLAY: 415,
  PAUSE: 19,
  STOP: 413,
  REWIND: 412,
  FAST_FORWARD: 417,
  RED: 403,
  GREEN: 404,
  YELLOW: 405,
  BLUE: 406,
  CHANNEL_UP: 427,
  CHANNEL_DOWN: 428,
  VOLUME_UP: 447,
  VOLUME_DOWN: 448,
  MUTE: 449,
  INFO: 457,
  GUIDE: 458,
  TOOLS: 10135,
  MENU: 10133,
  SOURCE: 10072,
  EXIT: 10182,
};

export const WEBOS_KEYS: TVKeyMap = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  RETURN: 461, // LG uses 461 for back button
  PLAY: 415,
  PAUSE: 19,
  STOP: 413,
  REWIND: 412,
  FAST_FORWARD: 417,
  RED: 403,
  GREEN: 404,
  YELLOW: 405,
  BLUE: 406,
  CHANNEL_UP: 33, // PageUp on LG
  CHANNEL_DOWN: 34, // PageDown on LG
  VOLUME_UP: null, // Handled by system
  VOLUME_DOWN: null,
  MUTE: null,
  INFO: 457,
  GUIDE: null,
  TOOLS: null,
  MENU: null,
  SOURCE: null,
  EXIT: null,
};

/** Browser (Chrome/Firefox/Safari) — teclado de PC: setas, Enter e Esc=RETURN. */
export const BROWSER_KEYS: TVKeyMap = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  RETURN: 27, // Escape key in browser
  PLAY: null,
  PAUSE: null,
  STOP: null,
  REWIND: null,
  FAST_FORWARD: null,
  RED: null,
  GREEN: null,
  YELLOW: null,
  BLUE: null,
  CHANNEL_UP: null,
  CHANNEL_DOWN: null,
  VOLUME_UP: null,
  VOLUME_DOWN: null,
  MUTE: null,
  INFO: null,
  GUIDE: null,
  TOOLS: null,
  MENU: null,
  SOURCE: null,
  EXIT: null,
};

/**
 * Desktop (wrapper Tauri) usa o MESMO teclado do browser — é um PC, não uma TV:
 * setas + Enter + Escape, e nenhuma tecla de controle remoto. O mapa era uma cópia
 * byte-a-byte de {@link BROWSER_KEYS}, então virou alias: mantém o nome (a API
 * pública e o `DesktopPlatformService.keys` seguem iguais) sem duas listas de 27
 * teclas pra manter em sincronia.
 *
 * Se o desktop um dia precisar de tecla própria (ex.: o wrapper interceptar F11),
 * volte a ser um objeto literal — o alias existe porque hoje não há divergência.
 * As teclas físicas de mídia/kiosk são interceptadas no wrapper Rust, não aqui.
 */
export const DESKTOP_KEYS: TVKeyMap = BROWSER_KEYS;
